import React from "react";
import { useState } from "react";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import "./../styles.css";

export default function ScrollToTopButton() {
  const [showBtn, setShowBtn] = useState("myBtn none");

  // When the user scrolls down 20px from the top of the document, show the button
  window.onscroll = function () {
    scrollFunction();
  };

  function scrollFunction() {
    if (
      document.body.scrollTop > 100 ||
      document.documentElement.scrollTop > 100
    ) {
      setShowBtn("myBtn");
    } else {
      setShowBtn("none");
    }
  }

  // When the user clicks on the button, scroll to the top of the document
  function topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  return (
    <button
      onClick={topFunction}
      id="myBtn"
      className={showBtn}
      title="Go to top"
    >
      <ExpandLessIcon />
    </button>
  );
}
